

define(['jquery', 'squid/index', 'text!./template.html', 'components/xo-models/src/fi/index', 'components/xo-ui-components/src/dropdown/directive', 'components/xo-ui-components/src/error-tooltip/directive'], function ($, squid, template) {

    return squid.module('xo-add-bank.bank-input.directive', ['squid', 'xomodel.fi', 'xo-dropdown.directive', 'xo-error-tooltip.directive']).directive('xoBankInput', function ($rootScope) {
        return {
            template: template,

            scope: {
                user: '=',
                bank: '='
            },

            /* auto formatting the user entered IBAN input */
            link: function link(scope, element, attr) {
                var IBANMask = 'AA00 0000 0000 0000 0000 0000 0000 0000 00';

                element.on('keyup', function (event) {

                    $('#ibanNumber').mask(IBANMask, {
                        'translation': {
                            0: { pattern: /[A-Za-z0-9]/ }
                        }
                    });
                });
            },

            controller: function controller($scope, $AddBankModel) {

                $scope.showIBAN = false;

                var days = [];
                var months = [];
                var years = [];

                var i;
                for (i = 1; i <= 31; i += 1) {
                    var d = i < 10 ? '0' + i : i.toString();
                    days.push(d);
                }

                for (i = 1; i <= 12; i += 1) {
                    var m = i < 10 ? '0' + i : i.toString();
                    months.push(m);
                }

                var year = new Date().getFullYear();

                for (i = year - 17; i >= year - 100; i -= 1) {
                    years.push(i);
                }

                $scope.days = days;
                $scope.months = months;
                $scope.years = years;

                $scope.toggleIBAN = function () {
                    $scope.showIBAN = !$scope.showIBAN;
                };
            }
        };
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-wallet-components/src/add-bank/bank-input/directive.js
 ** module id = 255
 ** module chunks = 1
 **/